import axios from "axios";
import { LoginModel } from "models/login_model";
import { useLayoutEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useGoogleLogin } from '@react-oauth/google';

const useAuth = () => {
  const [loading, setLoading] = useState(false);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const [error, setError] = useState(false);
  const cancelRef = useRef();

  const navigate = useHistory();

  const validate = () => {
    if (emailRef.current !== null && passwordRef.current !== null) {
      return true;
    } else {
      return false;
    }
  };

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log('Login bem-sucedido:', tokenResponse);
      
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/user/login-google",
        {
          token: tokenResponse.access_token,
        }
      );

      if (response.data) {
        setError(false);
        setLoading((prev) => (prev = false));
        localStorage.setItem("user", JSON.stringify(response.data));
        navigate.replace("/admin/");

        return;
      }

      setError(true);
      setLoading((prev) => (prev = false));
    },
    onError: () => {
      console.error('Erro ao tentar login');
      setError(true);
      setLoading((prev) => (prev = false));
    },
  });

  const login = async () => {
    setLoading(true);

    if (validate()) {
      const loginObj: LoginModel = {
        usuario: emailRef.current,
        senha: passwordRef.current,
      };
      axios({
        data: loginObj,
        baseURL: process.env.REACT_APP_API_URL + "/user/login",
        method: "POST",
      })
        .then((response) => {
          if (response.data) {
            setError(false);
            setLoading((prev) => (prev = false));
            localStorage.setItem("user", JSON.stringify(response.data));
            navigate.replace("/admin/");
          }
        })
        .catch((_) => {
          setError(true);
          setLoading((prev) => (prev = false));
        });
    }
  };

  const logOff = () => {
    localStorage.removeItem('user');
    navigate.replace("/auth/");
  };
  const closeError = () => {
    setError(false);
  };

  useLayoutEffect(() => {
    const getUser = () => {
      const user = localStorage.getItem("user");
      if (user) {
        navigate.replace("/admin/");
      }
    };
    getUser();
  }, []);

  return {
    login,
    logOff,
    loading,
    emailRef,
    passwordRef,
    error,
    cancelRef,
    closeError,
    handleGoogleLogin
  };
};

export default useAuth;
